{
	"gpuPerformanceWarningTitle": "Graphics Performance Issue Detected",
	"gpuPerformanceWarningMessage": "{{productName}} works best with modern graphics cards and hardware acceleration enabled, support on this device is experimental."
}
